// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Karla:400,700);"]);
// Module
exports.push([module.id, ".card-container {\n  max-width: 1000px;\n}\na {\n  color: #3782F3;\n}\n.redemptionObject {\n  background-color: #F0F9FF;\n  display: inline-block;\n  padding: 16px;\n  border-radius: 16px;\n  margin-top: 24px;\n}", ""]);
// Exports
module.exports = exports;
